<template>
	<div class="entity">
		<div class="entity__label">{{ label }} <span v-if="!optional">*</span></div>
		<div class="entity__content" @click="click">{{ entityLabel }}</div>
	</div>
</template>

<script>
	import ObjectWindow from '../windows/ObjectWindow'

	export default {
		data: function () {
			return {
				searchLabel: null
			};
		},
		props: {
			name: String,
			label: String,
			placeholder: String,
			id: Number,
			endpoint: String,
			optional: Boolean,
			windowStack: Object
		},
		asyncComputed: {
			entityLabel() {
				if (this.id) {
					var ent = this;

					return new Promise(function (resolve) {
						ent.axios
							.get(ent.endpoint + ent.id + '/')
							.then(function (r) {
								resolve(r.data.search_label);
							}, function () {
								resolve(ent.placeholder);
							});
					});
				} else {
					return this.placeholder;
				}
			}
		},
		mounted: function () {
			console.log(this.windowStack);
		},
		methods: {
			click() {
				var ent = this;

				this.windowStack.push(ObjectWindow, {
					title: this.label,
					endpoint: this.endpoint,
					onSelect: function (id, label) {
						console.log('callback');
						//ent.searchLabel = label;
						ent.$emit('input', ent.name, id, label);
					}
				});
			}
		}
	}
</script>

<style lang="scss">
	.entity {
		height: 52px;
		position: relative;

		&__label {
			position: absolute;
			pointer-events: none;
			left: 0;
			top: 0;
			font-size: 12px;
			color: #555963;

			& > span {
				color: #f7223f;
				font-size: 12px;
			}
		}		

		&__content {
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 30px;
			line-height: 30px;
			color: white;
			font-size: 14px;
			background-color: #202127;
			cursor: pointer;

			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
</style>